import { useLocale } from "../context/LocaleContext";
import React, { useState } from "react";
import { Outlet,useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import TopBar from "./TopBar";
import Footer from "./Footer";
import SourceAdvisor from "./SourceAdvisor";

import {LearningNavigation,ContentReport} from './LearningHub';
import {ReportTargetsProvider} from './ReportTargets';
export default function Layout() {
  const {pathname}=useLocation();
  const section={'/mahmut-efendim':'talks','/kutuphane':'library','/dergah-kutuphanesi':'physical_library','/soru-cevap':'questions','/haftalik-dersler':'lessons','/ilahiler':'hymns','/evrad-zikar':'evrad','/kasideler':'kaside','/canli-yayin':'live','/ayak-izleri':'footprints','/mahmut-efendim-ai':'assistant'}[pathname]||'journey';
  const [mobileOpen, setMobileOpen] = useState(false);
  const { t, locale } = useLocale();
  return (
    <div style={{ background: "var(--sy-bg)", minHeight: "100vh" }}><a href="#sayyadi-main" className="sy-skip-link">{t("Ana içeriğe geç")}</a>
      <Sidebar mobileOpen={mobileOpen} setMobileOpen={setMobileOpen} />
      <div className={["ar", "fa"].includes(locale) ? "lg:pr-[270px]" : "lg:pl-[270px]"}>
        <TopBar />{section==='assistant'?<details className="assistant-navigation"><summary>{t("Konular")}</summary><LearningNavigation/></details>:<LearningNavigation/>}
        <main id="sayyadi-main" tabIndex="-1">
          <ReportTargetsProvider key={pathname}><Outlet /><ContentReport resource={'section:'+section}/></ReportTargetsProvider>
        </main>
        <Footer />
        {section!=='assistant'&&<SourceAdvisor />}
      </div>
    </div>
  );
}

